const onEsc =
  (handler) =>
  (e, ...args) => {
    if (e.key === 'Tab') {
      handler(e, ...args);
    }
  };

export default onEsc;
